import React from "react";
import { COLORS } from "./tokens";

/**
 * MICRO ICON — RW-Feather.
 * An elegant vertical feather silhouette (line-art) with a central quill,
 * softly fanning barbs on both sides, and an integrated RW monogram at
 * the feather's heart. Spiritual, lightweight, embroidery-perfect.
 */
const MicroIcon = React.forwardRef(function MicroIcon(
  { size = 200, color = COLORS.sage, id = "rona-micro-icon" },
  ref
) {
  return (
    <svg
      ref={ref}
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 240 240"
      width={size}
      height={size}
      role="img"
      aria-label="Rona Wellness RW-feather monogram"
    >
      {/* Feather outline — slender tapered silhouette */}
      <path
        d="M 120 20
           C 94 36, 70 78, 68 128
           C 66 168, 96 200, 120 214
           C 144 200, 174 168, 172 128
           C 170 78, 146 36, 120 20 Z"
        fill="none"
        stroke={color}
        strokeWidth="2.6"
        strokeLinejoin="round"
      />

      {/* Central quill / spine — from feather tip to trailing stem */}
      <path
        d="M 120 20 L 120 232"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* Barbs — left side, gentle diagonal fans */}
      <g stroke={color} strokeOpacity="0.7" strokeWidth="1.3" strokeLinecap="round">
        <line x1="120" y1="46" x2="98" y2="54" />
        <line x1="120" y1="62" x2="86" y2="72" />
        <line x1="120" y1="80" x2="78" y2="92" />
        <line x1="120" y1="180" x2="88" y2="188" />
        <line x1="120" y1="196" x2="102" y2="204" />
      </g>
      {/* Barbs — right side */}
      <g stroke={color} strokeOpacity="0.7" strokeWidth="1.3" strokeLinecap="round">
        <line x1="120" y1="46" x2="142" y2="54" />
        <line x1="120" y1="62" x2="154" y2="72" />
        <line x1="120" y1="80" x2="162" y2="92" />
        <line x1="120" y1="180" x2="152" y2="188" />
        <line x1="120" y1="196" x2="138" y2="204" />
      </g>

      {/* RW monogram at the heart of the feather — elegant script */}
      <g fill="none" stroke={color} strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round">
        {/* Script R — stem + bowl + leg */}
        <path d="M 88 110 C 87 122, 87 134, 90 146" />
        <path
          d="M 89 112
             C 96 106, 106 106, 112 112
             C 118 118, 116 130, 108 134
             C 102 138, 94 137, 91 136"
        />
        <path d="M 104 134 C 110 140, 116 146, 122 150" />

        {/* Flowing connector between R and W */}
        <path d="M 122 150 C 126 151, 129 150, 131 148" strokeWidth="2.2" />

        {/* Script W — four undulating strokes */}
        <path
          d="M 128 112
             C 132 126, 138 140, 142 148
             C 145 152, 148 152, 151 148
             C 154 140, 157 132, 160 124
             C 162 120, 164 120, 165 124
             C 168 132, 171 140, 174 148"
        />
        {/* Trailing swash */}
        <path d="M 174 148 C 178 144, 180 140, 178 136" strokeWidth="2.2" />
      </g>
    </svg>
  );
});

export default MicroIcon;
